// MyCam 手機攝影機才有的資訊列（ls-loop MW；對齊 Android 觀看 App）：擷取狀態（CaptureState）、電量 / 電源、拔電立即通知開關。
// 放在「裝置資訊與維護」卡裡，HealthSection 只在手機攝影機時畫。
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BATTERY_LEVEL, CAPTURE_STATE, EXTERNAL_POWER, UNPLUG_ALERT } from './ids';
import { frameRawValue, opGet, useAttr } from './ops';
import { RowShell, ToggleRow } from './widgets';

export function PhoneCamRows({ deviceId, isOwner, wsOpen }: { deviceId: string; isOwner: boolean; wsOpen: boolean }) {
  const { t } = useTranslation();
  const level = useAttr(deviceId, BATTERY_LEVEL, wsOpen);
  const ext = useAttr(deviceId, EXTERNAL_POWER, wsOpen);
  const unplug = useAttr(deviceId, UNPLUG_ALERT, wsOpen);
  // CaptureState 是 composite（rawVal），useAttr 只認純值 → 自己讀一次
  const [cap, setCap] = useState<{ state?: string; reason?: string } | null>(null);
  useEffect(() => {
    if (!wsOpen) return;
    let alive = true;
    opGet(deviceId, CAPTURE_STATE)
      .then((f) => { if (alive) setCap((frameRawValue(f) as { state?: string; reason?: string }) ?? null); })
      .catch(() => { if (alive) setCap(null); });
    return () => { alive = false; };
  }, [deviceId, wsOpen]);

  const capText = !cap?.state ? '—'
    : cap.state === 'active' ? t('phonecam.capActive')
    : t('phonecam.capPaused', { reason: t(`phonecam.reason.${cap.reason ?? ''}`, { defaultValue: cap.reason ?? '' }) });
  const plug = ext.value === true ? t('phonecam.plugged') : ext.value === false ? t('phonecam.unplugged') : '';

  return (
    <>
      <RowShell label={t('phonecam.captureState')}>
        <span data-testid="pc-capture" className={cap?.state === 'paused' ? 'text-danger' : undefined}>{capText}</span>
      </RowShell>
      <RowShell label={t('phonecam.battery')}>
        <span data-testid="pc-battery">{typeof level.value === 'number' ? t('phonecam.batteryValue', { level: level.value, plug }) : '—'}</span>
      </RowShell>
      <ToggleRow label={t('phonecam.unplugAlert')} hint={t('phonecam.unplugAlertHint')} attr={unplug} disabled={!isOwner} />
    </>
  );
}
